import { AppBundle } from 'api/optimalprint-sdk.d';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import { setCategoryFiltersSelectionAction } from 'store/category/slice';

const isAttributeFilter = (key: string) => key !== 'color';

const filterValues = (attribute: string, value: string[]) => ({
  typeName: attribute,
  name: '',
  optionTemplate: '',
  options: value.map(
    (v) =>
      ({
        value: v,
        isSelected: true,
      } as AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.FilterOption),
  ),
});

export const filtersFromQueryString = (queryString: URLSearchParams | any) => {
  const ignoreParams = ['sortBy', 'voucher', 'pageNr'];
  const filters = {
    attributeFilters: [],
    tagFilters: [],
  } as AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters;

  let queryObject = queryString;
  if (queryString instanceof URLSearchParams) {
    queryObject = {};
    [...queryString.keys()].forEach((key) => {
      const values = queryString.getAll(key);
      queryObject[key.replace('[]', '')] = values.length > 1 ? values : values[0];
    });
  }

  Object.keys(queryObject).forEach((key: any) => {
    const value = queryObject[key];
    if (ignoreParams.indexOf(key) > -1) return;
    if (key.substring(0, 3) === 'ab_') return;

    const valueArr: string[] = Array.isArray(value) ? value : [value];

    if (isAttributeFilter(key)) {
      filters.attributeFilters.push(filterValues(key, valueArr));
    } else {
      filters.tagFilters.push(filterValues(key, valueArr));
    }
  });
  return filters;
};

const setCategoryFiltersSelectionPHPWayOperation =
  (queryString: URLSearchParams | any) => (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
    dispatch(setCategoryFiltersSelectionAction(filtersFromQueryString(queryString)));
  };

export default setCategoryFiltersSelectionPHPWayOperation;
